import { render, staticRenderFns } from "./EcCard.vue?vue&type=template&id=99d596de&scoped=true"
import script from "./EcCard.vue?vue&type=script&lang=js"
export * from "./EcCard.vue?vue&type=script&lang=js"
import style0 from "./EcCard.vue?vue&type=style&index=0&id=99d596de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d596de",
  null
  
)

export default component.exports